export class ValueConvertError extends Error {

}